import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import ImpersonationBanner from "./ImpersonationBanner";

export default function AppLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <div className="sticky top-0 z-30">
        <ImpersonationBanner />
        <TopBar onMenuClick={() => setDrawerOpen(true)} />
      </div>

      <div className="flex-1 md:grid md:grid-cols-[240px_1fr]">
        <aside className="hidden md:block md:sticky md:top-16 md:h-[calc(100vh-4rem)]">
          <Sidebar />
        </aside>

        {drawerOpen && (
          <>
            <div
              className="fixed inset-0 top-16 bg-slate-900/40 z-30 md:hidden"
              onClick={() => setDrawerOpen(false)}
              aria-hidden="true"
            />
            <aside className="fixed top-16 bottom-0 left-0 w-60 z-40 md:hidden">
              <Sidebar onNavigate={() => setDrawerOpen(false)} />
            </aside>
          </>
        )}

        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
